import { grey } from '@material-ui/core/colors';
export var itemBackground = grey['200'];
export var subText = grey['600'];
